export const ugcItemTypeVideo = 0
export const ugcItemTypeImageCollection = 1
export const ugcItemTypeNovel = 2
export const ugcItemTypeUgcArticle = 3
export const ugcItemTypeMovie = 4
export const ugcItemTypeSeries = 5
export const ugcItemTypeMomentUgc = 6
export const ugcItemTypeMomentCraw = 7
export const ugcItemTypeComic = 8
export const ugcItemTypeComicWt = 9

export const defaultAvatarUrl = "http://a1.wanwanshequ.com/static/public/image57e4avatar.png"

let tabbarConfig = [{
  name: "书城",
  icon: "book-store",
  iconFill: "book-store-fill",
  login: false,
  path: "/_tab_novel",
  pathIndex: "_tab_novel",
},{
  name: "漫画",
  icon: "Cartoon-Picture",
  iconFill: "Cartoon-Picture1",
  login: true,
  path: "/_tab_comic",
  pathIndex: "_tab_comic",
},
  {
  name: "视频",
  icon: "play",
  iconFill: "play1",
  login: true,
  path: "/_tab_discovery",
  pathIndex: "_tab_discovery",
}, {
  name: "动态",
  icon: "moments",
  iconFill: "moments-fill",
  login: true,
  path: "/_tab_moment",
  pathIndex: "_tab_moment",
}, {
  name: "我的",
  icon: "me",
  iconFill: "me-fill",
  login: true,
  path: "/_tab_mine",
  pathIndex: "_tab_mine",
}]

if (process.env.VUE_APP_APP_ID === "app_ns") {
  tabbarConfig = [{
    name: "视频",
    icon: "play",
    iconFill: "play1",
    login: true,
    path: "/_tab_discovery",
    pathIndex: "_tab_discovery",
  }, {
    name: "书城",
    icon: "book-store",
    iconFill: "book-store-fill",
    login: true,
    path: "/_tab_novel",
    pathIndex: "_tab_novel",
  }, {
    name: "我的",
    icon: "me",
    iconFill: "me-fill",
    login: true,
    path: "/_tab_mine",
    pathIndex: "_tab_mine",
  }]
}


export const TabbarConfig = tabbarConfig

